Ext.ns('mx.data');

mx.data.BufferedStore = function(config) {
    var cfg = config || {};
    if (!cfg.defaultResult) {
        cfg.defaultResult = 30;
    }
    if (!cfg.bufferWindowParams) {
        cfg.bufferWindowParams = {
            start: 'startIndex',
            limit: 'results',
        };
    }
    Ext.apply(this, cfg);
    mx.data.BufferedStore.superclass.constructor.call(this, config);
};

Ext.extend(mx.data.BufferedStore, mx.data.Store, {
    load: function(options, conn) {
        var opt = options || {};
        var p = opt.params || {};
        if (p) {
            if (p[this.bufferWindowParams['start']] == undefined) {
                p[this.bufferWindowParams['start']] = this.bufferWindow ? this.bufferWindow.start : 0;
            }
            if (p[this.bufferWindowParams['limit']] == undefined) {
                p[this.bufferWindowParams['limit']] = this.bufferWindow ? this.bufferWindow.limit : this.defaultResult;
            }
        }
        opt.params = p;
        return mx.data.BufferedStore.superclass.load.call(this, options, conn);
    },
    reset: function() {
        delete this.bufferWindow;
    },
    loadRecords: function(o, options, success) {
        this.bufferWindow = {
            start: options.params[this.bufferWindowParams['start']],
            limit: 0,
        };
        if (o && success === true) {
            var r = o.records;
            if (r.length) {
                this.bufferWindow.limit = r.length;
            }
        }
        mx.data.BufferedStore.superclass.loadRecords.call(this, o, options, success);
    },
    getAt: function(index, fakeIndex) {
        var idx = index;
        if (fakeIndex) {
            idx = index - this.bufferWindow['start'];
        }
        return mx.data.BufferedStore.superclass.getAt.call(this, idx);
    },
});
